import { render, staticRenderFns } from "./AddClinicalSkillsGroupModal.vue?vue&type=template&id=89918fa0&scoped=true&"
import script from "./AddClinicalSkillsGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddClinicalSkillsGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89918fa0",
  null
  
)

export default component.exports